import axios from 'axios';
import Constants, { fixProtocol } from '../../../constants/constants';
import { RestorativeProgram } from './types';

export const updatePlayerRestorativeFlag = async (
  id: number,
  restorativePrograms: RestorativeProgram[],
  flag = true
) => {
  const restorativeProgramIds = restorativePrograms.map((program) => {
    return program.id;
  });

  const url = new URL(`${fixProtocol(Constants.BACKEND_URL)}/players/update-player-restorative-flag`);

  const config = {
    player_id: id,
    restorative: flag,
    restorative_program_ids: restorativeProgramIds,
  };
  try {
    const response = await axios.post(url.toString(), config);
    return response;
  } catch (e) {
    return false;
  }
};
